module.exports = __webpack_public_path__ + "img/export.d8925976.svg";